export default "__VITE_ASSET__BJiruhTS__"